<section class="d-flex justify-content-center align-items-center">
  <div class="py-5 px-3">
    <div class="text-right">
      <img
        (click)="activeModal.close('closed modal')"
        src="/assets/icons/close-sheet.svg"
        alt="close"
      />
    </div>
    <div class="my-3 text-center">
      <img src="/assets/icons/serving-waiter.svg" alt="call a waiter" />
    </div>

    <div class="form-section">
      <h4 class="f-20 secondary-font-bold">Self order</h4>
      <p class="mb-3 primary-font-normal">
        Please enter your table number to enable us serve you. Thank you!
      </p>
      <app-table-form
        [buttonText]="'Proceed'"
        (tableNumberEmitter)="collectTableNumber($event)"
      ></app-table-form>
    </div>
  </div>
</section>
